module.exports = __webpack_public_path__ + "static/media/Spartan051_2c.b12e2aec.svg";